import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    stisLoading : false,
    ticketType: [],
    totalTicketType: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    stiscLoading:false,
    stcstatus:"",
    stcMessage:"",
    stdetails:{},
    stismloading:false,
    stmstatus:"",
    stmmessage:"",
    stSDetails: {},
    stdstatus:"",
    stdmessage:"",
    error:"",
    
};


const ticketTypeSlice = createSlice({
    name: "ticketTypesList",
    initialState,
    reducers:{
        getTicketTypePending: (state) => {
            state.stisLoading = true;
        },
        getTicketTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.ticketType = payload;
            state.stdetails = payload;
        
            state.error = '';
        },
        getTicketTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        createTicketTypePending:(state,action) => {
            state.stiscloading=true;
        },
        createTicketTypeSuccess:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="success";
            state.stcmessage=payload;
        },
        createTicketTypeFail:(state,{payload}) => {
            state.stiscloading=false;
            state.stcstatus="fail";
            //console.log('slice '+payload);
            state.stcMessage=payload;
        },
        getSTicketTypePending: (state) => {
            state.stisLoading = true;
        },
        getSTicketTypeSuccess: (state, { payload }) => {
            state.stisLoading = false;
            state.stSDetails=payload;
            state.error = '';
        },
        getSTicketTypeFail: (state, { payload }) => {
            state.stisLoading = false;
            state.error = payload;
        },
        modifyTicketTypePending:(state,action) => {
            state.stismloading=true;
            state.stmstatus="";
        },
        modifyTicketTypeSuccess:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="success";
           
            state.stmmessage="Ticket Type Successfully Updated";
        },
        modifyTicketTypeail:(state,{payload}) => {
            state.stismloading=false;
            state.stmstatus="fail";
           // console.log('slice '+payload);
            state.stmmessage=payload;
        },
        deleteTicketTypePending:(state,action) => {
            state.stisloading=true;
            state.stdstatus="";
        },
        deleteTicketTypeSuccess:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="success";
            state.stdmessage="Ticket Type Successfully Deleted";
        },
        deleteTicketTypeFail:(state,{payload}) => {
            state.stisLoading=false;
            state.stdstatus="fail";
           // console.log('slice '+payload);
            state.stdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = ticketTypeSlice;

export const { getTicketTypePending, getTicketTypeSuccess, getTicketTypeFail,getSTicketTypePending, getSTicketTypeSuccess, getSTicketTypeFail, 
    createTicketTypePending, createTicketTypeSuccess, createTicketTypeFail,
    modifyTicketTypePending,modifyTicketTypeSuccess,modifyTicketTypeFail,
    deleteTicketTypePending,deleteTicketTypeSuccess,deleteTicketTypeFail  } = actions;

export default reducer;
